@if (hasBackdrop) {
  <div class="mat-drawer-backdrop" (click)="_onBackdropClicked()"
       [class.mat-drawer-shown]="_isShowingBackdrop()"></div>
}

<ng-content select="mat-drawer, mat-sidenav"/>
<ng-content select="mat-drawer-content, mat-sidenav-content"/>

@if (!_content) {
  <mat-sidenav-content>
    <ng-content/>
  </mat-sidenav-content>
}
